document.addEventListener('DOMContentLoaded', function() {
  if (typeof maxQuantity !== 'undefined') {
    const quantityInput = document.querySelector('input[name="quantity"]');

    if (quantityInput) {
      quantityInput.addEventListener('change', function() {
        const quantity = parseInt(quantityInput.value);
        if (quantity > maxQuantity) {
          alert('この授与品の申込数は最大' + maxQuantity + '体です。');
          quantityInput.value = maxQuantity;
        }
      });
    }
  }
});